import { render, staticRenderFns } from "./CaseManager.vue?vue&type=template&id=84c65fc2&scoped=true"
import script from "./CaseManager.vue?vue&type=script&lang=js"
export * from "./CaseManager.vue?vue&type=script&lang=js"
import style0 from "./CaseManager.vue?vue&type=style&index=0&id=84c65fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c65fc2",
  null
  
)

export default component.exports